"use strict";
/**
 * Created by Ning Jiang on 2/15/2017.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReelSymbolName = void 0;
class ReelSymbolName {
}
ReelSymbolName.WILD = "W";
ReelSymbolName.SCATTER = "S";
ReelSymbolName.BONUS = "B";
ReelSymbolName.MYSTERY = "M";
ReelSymbolName.EMPTY = "X";
exports.ReelSymbolName = ReelSymbolName;
//# sourceMappingURL=ReelSymbolName.js.map